import { Button, FormGroup, InputLabel, OutlinedInput } from '@mui/material'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { Container, ContainerForm, Title } from '../../styles/index.sty';
import AlertSnack from '../../components/Alert/AlertSnack'
import { insertUserData, updateUserData } from '../../api/users.api'
import { useLists } from '../../context/listContext'

export const AddUser = () => {
  const [ loading, setLoading ] = useState(false);
  const { fetchUsersList } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [ response, setResponse ] = useState({});
  const formik = useFormik({
    initialValues: {
    first_name: location?.state?.data?.first_name,
    last_name: location?.state?.data?.last_name,
    mobile_no: location?.state?.data?.mobile_no,
    email: location?.state?.data?.email,
    },
    onSubmit: async values => {
      setLoading(true);
      if (location?.state?.data) {
        const submit = await updateUserData({...values, user_id: location?.state?.data?.user_id});
        setResponse(submit);
        setOpen(true);
        fetchUsersList();
        if(submit.status === "success") {
          navigate("/customers");
        }
      } else {
        const submit = await insertUserData(values);
        setResponse(submit);
        setOpen(true);
        fetchUsersList();
        if(submit.status === "success") {
          navigate("/customers");
        }
      }
    },
  });

  // const handleClose = (event, reason) => {
  //   if (reason === 'clickaway') {
  //     return;
  //   }

  //   setOpen(false);
  // };

  // const handleResponse = (data) => {
  //   setLoading(false);
  //   setMsg(data.msg);
  //   setSeverity(data.status);
  //   setOpen(true);
  //   if (data.status === "success") {
  //     navigate("/customers")
  //   }
  // }

  return (
    <>
    <Container>
      <Title variant='h5' className='w-[100%]'>Enter User Details.</Title>
      <ContainerForm>

      {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="customers"/>}

      {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
        <div style={{width : "60%", margin: "auto"}} >
        <FormGroup>
          <InputLabel htmlFor="first_name">First Name: </InputLabel>
          <OutlinedInput
            name="first_name"
            placeholder="Enter First Name"
            id="first_name"
            type="text"
            value={formik.values.first_name}
            onChange={formik.handleChange}
            />
        </FormGroup>
        <FormGroup>
          <InputLabel htmlFor="last_name">Last Name: </InputLabel>
          <OutlinedInput
            name="last_name"
            placeholder="Enter Last Name"
            id="last_name"
            type="text"
            value={formik.values.last_name}
            onChange={formik.handleChange}
            />
        </FormGroup>
        <FormGroup>
          <InputLabel htmlFor="email">E-mail: </InputLabel>
          <OutlinedInput
            name="email"
            placeholder="Enter E-mail"
            id="email"
            type="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            />
        </FormGroup>
        <FormGroup>
          <InputLabel htmlFor="mobile_no">Mobile Number: </InputLabel>
          <OutlinedInput
            name="mobile_no"
            placeholder="Enter Mobile Number"
            id="mobile_no"
            type="number"
            value={formik.values.mobile_no}
            onChange={formik.handleChange}
            />
        </FormGroup>
        {/* <FormGroup>
          <InputLabel htmlFor="dob">Date Of Birth: </InputLabel>
          <OutlinedInput
          name="dob"
          id="dob"
          type="date"
          value={formik.values.dob}
          onChange={formik.handleChange}
          />
        </FormGroup> */}
        {/* <FormGroup>
          <InputLabel id="userTypeLabel">User Type: </InputLabel>
          <Select
          labelId="userTypeLabel"
          id="userTypeSelect"
          value={userType}
          label="User Type: "
          onChange={(e) => setUserType(e.target.value)}
          >
          <MenuItem value={"Admin"}>Admin</MenuItem>
          <MenuItem value={"Customer"}>Customer</MenuItem>
          <MenuItem value={"Manager"}>Manager</MenuItem>
          </Select>
        </FormGroup> */}
        <div className='flex flex-row justify-around'>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={() => navigate("/users")}
            style={{
              margin: "1rem",
              width: "30%"
            }}
            >
            Back
          </Button>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={formik.handleSubmit}
            style={{
              margin: "1rem",
              width: "30%"
            }}
            >
            Create
          </Button>
        </div>
        {/* <Button
          fullWidth
          type="button"
          variant='contained'
          color='info'
          onClick={logList}
          style={{
            margin: "1rem auto"
          }}
          >
          Click Me TO Check
        </Button> */}
        </div>}
      </ContainerForm>
    </Container>
    </>
  )
};